import { Component, ViewChild } from '@angular/core';
import { NgbDropdownModule, NgbModal, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { NoDataComponent } from '../../../Component/NoData/no-data/no-data.component';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-zing-hr',
  standalone: true,
  imports: [CommonModule, RouterModule, DataTablesModule, NgbProgressbarModule, FormsModule, NgbDropdownModule, NgSelectModule,LoaderComponent, NoDataComponent],
  templateUrl: './zing-hr.component.html',
  styleUrl: './zing-hr.component.scss'
})
export class ZingHRComponent {
  isDisabled: boolean = false;
  EmployeeData = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};

  Filter = {
    SelectType: 'S',
    EmpCode: null,
  }

  SyncEmployee = {
    EmpCode: null,
  }

  constructor(
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private modalService: NgbModal,
    private toast: ToastService,
    private router: Router,
  ) {
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
    this.dtoptions.ordering = false;
    this.dtoptions.columnDefs = [
      {
        targets: 0,
        width: '250px',
      },
      {
        targets: 1,
        width: '60px',
      },
    ];
  }

  ngOnInit(): void {
    this.ESS_EmpZingHrSyncSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_EmpZingHrSyncSelect() {
    this.isDisabled = true;
    this.employeeRegistration.ESS_EmpZingHrSyncSelect(this.Filter).subscribe({
      next: (response) => {
        this.EmployeeData = Object.values(response)

        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { 
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  CheckEditOrSync(index: number, type: string) {
    if (this.common.ToLowerCase(this.EmployeeData[index].Status) == 'synced') {
      if (type == 'i') {
        this.router.navigate(['/onboarding/zinghr/add/' + this.EmployeeData[index].EmpMaster_DraftID + '/true']);
      } else {
        this.router.navigate(['/onboarding/zinghr/detail/' + this.EmployeeData[index].EmpMaster_DraftID + '/true']);
      }
    } else {
      this.ESS_EmpZingHrSyncInESS(this.EmployeeData[index].EmpMaster_DraftID, type);
    }
  }

  ESS_EmpZingHrSyncInESS(EmpMasterID: number, type: string) {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to sync?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.employeeRegistration.ESS_EmpZingHrSyncInESS({ SelectType: 'Sync', EmpMasterID: EmpMasterID }).subscribe({
          next: (response) => {
            if (response.Error_Code == '01') {
              if (type == 'i') {
                this.router.navigate(['/onboarding/zinghr/add/' + EmpMasterID + '/true']);
              } else {
                this.router.navigate(['/onboarding/zinghr/detail/' + EmpMasterID + '/true']);
              }
              // const modalRef = this.modalService.open(AlertSuccessComponent, {
              //   size: 'md',
              //   backdrop: 'static',
              //   centered: true,
              //   windowClass: 'confirmation-modal'
              // });
              // modalRef.componentInstance.Message = response.Error_Message;
              // modalRef.result.then((result: any) => {
              //   if (result) {
              //     this.ESS_EmpZingHrSyncSelect();
              //   }
              // });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  toggleRow(i: number): void {
    this.EmployeeData[i].expanded = !this.EmployeeData[i].expanded;
  }

  zinghrEmployeeSync(form: any) {
    if (form.valid) {
      if (this.SyncEmployee.EmpCode != null && this.SyncEmployee.EmpCode != '') {
        const modalRef = this.modalService.open(ConfirmationComponent);
        modalRef.componentInstance.Message = 'Do you want to sync?';
        modalRef.result.then(result => {
          if (result) {
            this.isDisabled = true;
            this.employeeRegistration.zinghrEmployeeSyncData({ EmployeeCode: this.SyncEmployee.EmpCode }).subscribe({
              next: (response) => {
                if (response.Error_Code == '01') {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    if (result) {
                      this.isDisabled = false;
                      this.ESS_EmpZingHrSyncSelect();
                    }
                  });
                } else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    this.isDisabled = false;
                  });
                }
              },
              complete: () => {
                this.isDisabled = false;
              },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        });
      } else {
        this.toast.show({ message: 'Please enter zing hr employee code', type: toastTypeEnum.warning });
      }
      form.submitted = false;
    } else {
      this.toast.show({ message: 'Please enter zing hr employee code', type: toastTypeEnum.warning });
      form.submitted = true;
    }

  }
}
